import {
  deleteAdminV1MeSessionsId,
  getAdminV1MeSessions,
  patchAdminV1Me,
  postAdminV1AuthEmailConfirm,
  postAdminV1MeEmailChange,
  postAdminV1MePassword,
  postAdminV1MeSessionsRevokeOthers,
  type ChangeEmailRequest,
  type EmailChanged,
  type RevokedSessions,
  type StaffChangePasswordRequest,
  type StaffProfile,
  type StaffSession,
  type UpdateMeRequest,
} from '@nucleus-commerce/api-client/admin';

/** The signed-in staff member's own account; every call acts on "me", never on someone else. */
export const accountApi = {
  update: (body: UpdateMeRequest): Promise<StaffProfile> => patchAdminV1Me(body),
  sessions: (): Promise<StaffSession[]> => getAdminV1MeSessions().then((r) => r.items),
  /** Revoking the current session signs this browser out. */
  revokeSession: (id: string): Promise<void> => deleteAdminV1MeSessionsId({ id }),
  revokeOtherSessions: (): Promise<RevokedSessions> => postAdminV1MeSessionsRevokeOthers(),
  /** 422 on `body.currentPassword` when it is wrong; other sessions end on success. */
  changePassword: (body: StaffChangePasswordRequest): Promise<void> => postAdminV1MePassword(body),
  /** 202: a confirmation link goes to the new address; nothing changes until it is opened. */
  requestEmailChange: (body: ChangeEmailRequest): Promise<void> => postAdminV1MeEmailChange(body),
  /** Public: the link works without a session. */
  confirmEmail: (token: string): Promise<EmailChanged> =>
    postAdminV1AuthEmailConfirm({ token }, { skipUnauthorizedHook: true }),
};
